import { render, staticRenderFns } from "./ordersResume.vue?vue&type=template&id=eae61940&scoped=true&"
import script from "./ordersResume.vue?vue&type=script&lang=js&"
export * from "./ordersResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae61940",
  null
  
)

export default component.exports